export const privacyPolicyUrl = 'http://www.haymarket.com/privacy-policy/';



// WEBPACK FOOTER //
// ./src/constants/globals.js